import { makeActions } from '@redux/crudCreator/actions';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { completePickApi } from 'api/orders';

export const MODEL_NAME = 'ordersDetail';
export const ordersDetailActions = makeActions(MODEL_NAME, 'id', 'orders');

export const getAllOrdersDetail = ordersDetailActions.getAll;
export const editOrdersDetail = ordersDetailActions.edit;
export const createOrdersDetail = ordersDetailActions.create;
export const getByIdOrdersDetail = ordersDetailActions.getDataById;

export const completePick = createAsyncThunk(
  'ordersDetail/completePick',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        completePickApi,
        data,
      );
      if (response) {
        return {
          ...response,
          ...payload,
        };
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
